import React from 'react'
import { useSelector } from 'react-redux';
import { selectOrgAliases } from 'redux/configurations/selectors';

export default function TextAlias(props) {
  const aliases = useSelector(selectOrgAliases);
  return (
    <span>
      {aliases[props.children]? `${aliases[props.children]}` : props.children}
    </span>
  )
}
